import type { SupportedLocale } from '@/shared/i18n/locales';
import { useLocaleStore } from '../store';

export function useLanguage() {
  const lang = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);

  return {
    lang,
    changeLang: (locale: SupportedLocale) => setLocale(locale),
  };
}
